import { LoadingOutlined } from '@ant-design/icons';
import { FileHttp, MessageHttp } from '@/services';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Flex, LoadingSpin, PageContainer } from '@/components';

export function MessageDetailPage() {

  const { id } = useParams();

  const [t] = useTranslation(['common']);

  const { isFetching, data } = useQuery({
    queryKey: ['/core/message', id],
    queryFn: async () => (await MessageHttp.findById(id))?.payload,
  });

  return (
    <PageContainer title={t('common:labels.message')}>
      {isFetching ? <LoadingSpin /> :
        <Flex direction="column">
          <Flex className="ps-4 text-[#4d4d4d]" direction="column" style={{ borderInlineStart: '3px solid #BCBCBC' }}>
            <div className="flex font-bold text-lg">{data?.message?.subject}</div>
            <div dangerouslySetInnerHTML={{
              __html: data?.message?.body
                ? new TextDecoder().decode(
                  Uint8Array.from(atob(data.message.body), c => c.charCodeAt(0))
                ) : ''
            }} />
          </Flex>
          {data?.message?.fileInfoIds?.length > 0 &&
            <Flex direction="row" className="mt-4" align="center">
              {data?.message.fileInfoIds?.map((fileId, i) => (
                <Flex key={i}>
                  <MessageAttachment
                    fileId={fileId}
                    title={t('common:labels.download-attachment')}
                  />
                  {((data?.message?.fileInfoIds?.length - 1) != i) &&
                    <span className="mx-2">|</span>
                  }
                </Flex>
              ))}
            </Flex>
          }
        </Flex>
      }
    </PageContainer >
  );
};

function MessageAttachment({
  title,
  fileId
}: { title: string; fileId: string }) {

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['/core/message/download', fileId],
    mutationFn: async () => (await FileHttp.downloadFile(fileId)),
  });

  return (
    <div className="flex items-center gap-2 text-blue-500">
      {isPending && <LoadingOutlined style={{ fontSize: 18 }} spin />}
      <span
        onClick={() => mutateAsync()}
        className="cursor-pointer">
        {title}
      </span>
    </div>
  );
}

export default MessageDetailPage;
